export const passwordRequirementRegExp = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-*.!@$%^&(){}[\]:;<>,.?/~_+=|])/

export const recoveryCodeRegExp = /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/

export const fcraIdRegExp = /^(\d{8,10}|\d{6}[A-Z]{2}\d{3})$/
